import { Locale } from '@peloton/internationalize';
import { parseSearch } from '@peloton/redux';
import { TagModalView, TAGS_MODAL_NAME } from '@engage/tags';
export var LoginPage;

(function (LoginPage) {
  LoginPage["Activation"] = "Activation";
  LoginPage["MiniApp"] = "MiniApp";
  LoginPage["Social"] = "Social";
  LoginPage["Standard"] = "Standard";
  LoginPage["Tags"] = "Tags";
  LoginPage["WebTV"] = "WebTV";
})(LoginPage || (LoginPage = {}));

var isTagsPath = function isTagsPath(location) {
  var searchParams = parseSearch(location);
  return searchParams.modal === TAGS_MODAL_NAME && searchParams.tagsView === TagModalView.TagDetails;
};

var getTag = function getTag(location) {
  var _searchParams$tagName;

  var searchParams = parseSearch(location);
  return (_searchParams$tagName = searchParams.tagName) !== null && _searchParams$tagName !== void 0 ? _searchParams$tagName : '';
};

export var getOauthFragment = function getOauthFragment(location) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Locale.EnglishUnitedStates;
  var requesterEmail = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

  if (isTagsPath(location)) {
    return {
      type: LoginPage.Tags,
      tag: getTag(location),
      message: '',
      locale: locale,
      requesterEmail: requesterEmail
    };
  }

  return {
    type: LoginPage.Standard,
    message: message,
    locale: locale,
    requesterEmail: requesterEmail
  };
};
export var safelyDecodeFragment = function safelyDecodeFragment(fragment) {
  try {
    return JSON.parse(window.decodeURIComponent(fragment));
  } catch (e) {
    return {
      type: LoginPage.Standard,
      message: '',
      locale: Locale.EnglishUnitedStates,
      requesterEmail: ''
    };
  }
};